module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Рідне Слово")]), _vm._v(" "), _c('p', [_vm._v("Увійдіть або зареєструйтеся на цьому веб-сайті за допомогою кнопки входу нижче.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-dark",
    on: {
      "click": function($event) {
        _vm.authenticate()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "sign-in"
    }
  }), _vm._v("Увійти")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa9eb0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 619
// module chunks = 1